(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/components/top-bottom-border.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/transcript/components/top-bottom-border.js');
'use strict';

const isPnp = svs.core.config.data.svsconfig.site === 'momang';

const TopBottomBorder = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("p", {
    className: "u-border-top-1 u-border-bottom-1 padding-v-1 ".concat(isPnp ? 'border-white' : 'border-navy')
  }, children);
};
svs.myProfile.react.pages.myInformation.transcript.transcript.TopBottomBorder = TopBottomBorder;

 })(window);